import {gsap} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("DOMContentLoaded", function () {
  
  const animateEls = gsap.utils.toArray('.animate');
  
  if(animateEls.length > 0) {
    animateEls.forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: 'top bottom',
          end: 'bottom top',
          trigger: el,
          toggleClass: 'is-inview',
          once: true
        }
      });
    });
  }

});